// extracted by mini-css-extract-plugin
export default {"title":"TitleBlock_title__G9sHi"};